import * as Constants from '../constants/member-tiers';

const initialState = {
  allMemberTiers: [],
  activeMemberTier: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Constants.GET_ALL_MEMBER_TIERS_SUCCESS:
      return {
        ...state,
        allMemberTiers: action.payload,
      };
    case Constants.GET_MEMBER_TIER_SUCCESS:
      return {
        ...state,
        activeMemberTier: action.payload,
      };
    case Constants.CLEAR_ALL_MEMBER_TIERS_SUCCESS:
      return {
        ...state,
        allMemberTiers: [],
      };
    case Constants.CLEAR_ACTIVE_MEMBER_TIER_SUCCESS:
      return {
        ...state,
        activeMemberTier: [],
      };
    default:
      return state;
  }
};
